export default "__VITE_ASSET__DlcDViMZ__"